import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { activeDeleteImages } from "../../store/actions/DeleteImageAction";
import "./addHolders.scss";

const useStyles = makeStyles({
    inputFile: {
        height: 96,
        display: 'none',
    },
    photos: {
        objectFit: 'cover',
        minHeight: 80,
        width: '100%',
    },
    addButton: {
        width: '100%',
        height: '100%',
    }
})

const Photo = (props) => {
    const classes = useStyles()
    const {
        name,
        value,
        setFieldValue,
        flagEdit,
        deleteImg,
        index,
        cancelData,
        setCancelData,
        activeDeleteImages,
        item,
        holders,
        lawyers,
        certificationsLawyer,
        awardsLawyer,
        setErase,
    } = props

    const [ dataPhoto, setDataPhoto ] = useState('')

    useEffect(() => {
        let local
        // IF CERT
        if (name.includes('Cert')) {
            if (
                holders &&
                holders[item] &&
                holders[item].certifications &&
                holders[item].certifications[index] &&
                holders[item].certifications[index].myImageCert &&
                holders[item].certifications[index].myImageCert.includes('firebase')
            ) {
                local = holders[item].certifications[index].myImageCert
            } else if (
                lawyers &&
                lawyers[item] &&
                lawyers[item].certifications &&
                lawyers[item].certifications[index] &&
                lawyers[item].certifications[index].myImageCert &&
                lawyers[item].certifications[index].myImageCert.includes('firebase')
            ) {
                local = lawyers[item].certifications[index].myImageCert
            } else if (
                certificationsLawyer &&
                certificationsLawyer[index] &&
                certificationsLawyer[index].myImageCert &&
                certificationsLawyer[index].myImageCert.includes('firebase')
            ) {
                local = certificationsLawyer[index].myImageCert
            }
            
            if (
                local &&
                local.includes('firebase') &&
                !deleteImg.certifications[index] &&
                value &&
                typeof value !== 'object' &&
                flagEdit
            ) {
                setDataPhoto(local)
            } else if (deleteImg.certifications[index]) {
                setDataPhoto('')
            }
        }

        // IF AWARD
        if (name.includes('Award')) {
            if (
                holders &&
                holders[item] &&
                holders[item].awards &&
                holders[item].awards[index] &&
                holders[item].awards[index].myImageAward &&
                holders[item].awards[index].myImageAward.includes('firebase')
            ) {
                local = holders[item].awards[index].myImageAward
            } else if (
                lawyers &&
                lawyers[item] &&
                lawyers[item].awards &&
                lawyers[item].awards[index] &&
                lawyers[item].awards[index].myImageAward &&
                lawyers[item].awards[index].myImageAward.includes('firebase')
            ) {
                local = lawyers[item].awards[index].myImageAward
            } else if (
                awardsLawyer &&
                awardsLawyer[index] &&
                awardsLawyer[index].myImageAward &&
                awardsLawyer[index].myImageAward.includes('firebase')
            ) {
                local = awardsLawyer[index].myImageAward
            }

            if (
                local &&
                local.includes('firebase') &&
                !deleteImg.awards[index] &&
                value &&
                typeof value !== 'object' &&
                flagEdit
            ) {
                setDataPhoto(local)
            } else if (deleteImg.awards[index]) {
                setDataPhoto('')
            }
        }

        // TO ADD
        if (cancelData) {
            setDataPhoto('')
            activeDeleteImages(name, index, false)
            setErase(false)
            if (!dataPhoto) {
                setCancelData(false)
                setErase(false)
            }
        }
    }, [
        item,
        name,
        value,
        index,
        holders,
        lawyers,
        flagEdit,
        setErase,
        dataPhoto,
        cancelData,
        awardsLawyer,
        setCancelData,
        deleteImg.awards,
        activeDeleteImages,
        certificationsLawyer,
        deleteImg.imgProfile,
        deleteImg.certifications,
    ])
    
    const handleChangeEditHolder = e => {
        let file = e.target.files[0], reader = new FileReader();
        reader.readAsDataURL(file);
        setFieldValue(name, file);
        reader.onload = (r) => {
            setDataPhoto(r.target.result)
        }
        activeDeleteImages(name, index, false)
    };

    const clickDeleteImage = () => {
        activeDeleteImages(name, index, true)
        setDataPhoto("")
        setFieldValue(name, '')
    }
    
    return (
        <div className="container_photo">
            {dataPhoto ?
                <div className="container_photo_image">
                    <img
                        src={dataPhoto}
                        alt="my_photo"
                        className={classes.photos}
                    />
                    <div className="trash">
                        <img
                            src="/img/profile/trash.svg"
                            onClick={clickDeleteImage}
                            alt="borrar"
                            className="trash_image"
                        />
                    </div>
                </div> :
                <div className="container_add">
                    <input
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        onChange={handleChangeEditHolder}
                        className={classes.inputFile}
                        id={name}
                        name={name}
                    />
                    <label
                        htmlFor={name}
                        className="container_label"
                    >
                        <Button
                            component="span"
                            className={classes.addButton}
                        >
                            <div className="container_add_image">
                                <img
                                    className="insertar-foto"
                                    style={{ width: 32 }}
                                    src="/img/profile/insertar-foto.svg"
                                    alt="add_photo"
                                />
                            </div>
                        </Button>
                    </label>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => ({
    uid: state.authClient.uid,
    deleteImg: state.DeleteImageReducer.deleteImg,
    holders: state.authClient.holders,
    lawyers: state.authClient.lawyers,
    certificationsLawyer: state.authClient.certificationsLawyer,
    awardsLawyer: state.authClient.awardsLawyer,
})

const mapDispatchToProps = dispatch => ({
    activeDeleteImages: (name, index, boolCancel) =>
        dispatch(activeDeleteImages(name, index, boolCancel)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Photo);
